export enum EInvoiceStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Disputed = 'DISPUTED',
  Failed = 'FAILED',
  NotIssuedByPlatform = 'NOT_ISSUED_BY_PLATFORM',
  Paid = 'PAID',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  PaymentSent = 'PAYMENT_SENT',
  Refused = 'REFUSED',
  Rejected = 'REJECTED',
  Sent = 'SENT',
  Submitted = 'SUBMITTED',
  Suspended = 'SUSPENDED',
}
